import { RAISE_API_V1_URL } from "constants/endpoints";
import { post, get } from "services/api";

const BRANDS_URL_TO_FETCH = `${RAISE_API_V1_URL}/list_brands`;

export const getBrands = async (query) => {
  const URL = BRANDS_URL_TO_FETCH + query;
  const response = await post(URL, null);
  return response.data;
};

export const getFilters = async () => {
  const resp = await get(`${RAISE_API_V1_URL}/product_sources/categories`);

  return resp.data;
};
